import { Dialog } from '../Dialog'
import { youtubeEmbedUrl } from './youtube'

const IFRAME_ALLOW =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'

export interface VideoPlayerDialogProps {
  videoId: string
  /** Заголовок iframe для скринридеров. */
  title: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Окно с плеером YouTube. Iframe монтируется, только пока окно открыто:
 * закрытие размонтирует его и останавливает видео.
 */
export function VideoPlayerDialog({ videoId, title, open, onOpenChange }: VideoPlayerDialogProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      className="max-w-[900px] overflow-hidden p-0"
      closeClassName="bg-black/50 text-white hover:bg-black/70 hover:text-white"
    >
      {open && (
        <div className="aspect-video w-full">
          <iframe
            src={youtubeEmbedUrl(videoId)}
            title={title}
            allow={IFRAME_ALLOW}
            allowFullScreen
            className="h-full w-full"
          />
        </div>
      )}
    </Dialog>
  )
}
